const processInclude = require('sfraScripts/util');
require('jquery-ui/ui/widgets/autocomplete');

$(document).ready(function() {
	processInclude(require('./login/login'));
	if ($(window).width() <= 900) {
		$('.order-sticky').show();
		$('.card.delivery-summary.order').addClass('collapsible');
		$('.card-header.order').addClass('clearfix collapsible-title card-header-custom');
		$('.card-body.order').addClass('collapse');
		$('edit-order-mobile').show();
		$('.edit-order-desktop').hide();		
	} else {
		$('.order-sticky').hide();
		$('edit-order-mobile').hide();
		$('.edit-order-desktop').show();
		$('.card.delivery-summary.order').removeClass('collapsible');
		$('.card-header.order').removeClass('clearfix collapsible-title card-header-custom');
		$('.card-body.order').removeClass('collapse');
	}
});

function calculateStickyMargin() {
	var windowWidth = $(window).width();
	var $checkoutMainEl = $('#checkout-main');
	if (windowWidth < 990) {
		var stickyHeight = $('.checkout-sidebar-sticky').height();
		$checkoutMainEl.css('margin-bottom', stickyHeight);
	} else {
		$checkoutMainEl.css('margin-bottom', 0);
	}
}

// TODO: Remove this and find better approach
$('.link-edit-order').on('click', function() {
	window.location.href = $('.link-edit-order').attr('href');
});

$('.delivery-summary').on('click', function(e) {
	e.preventDefault();
	resizeTimer = setTimeout( function() {
		calculateStickyMargin();
	}, 500);
});

$('#requestPasswordResetModal').on('hidden.bs.modal',  function () {
	if ($("#submitEmailButton").data('dismiss') == 'modal') {
		location.reload();
		$.spinner().start();
	}

	var checkoutLoginPage = $('#checkoutLoginPage').val();
	if (checkoutLoginPage && checkoutLoginPage === 'true') {
		var html = $('#requestPasswordResetModalBackup').html();
		$('#requestPasswordResetModal').empty().html(html);
	}
});

var resizeTimer;
$(window).resize(function(e) {
	clearInterval(resizeTimer);
	resizeTimer = setTimeout( function() {
		if ($(window).width() <= 900) {
			$('.order-sticky').show();
			$('.card.delivery-summary.order').addClass('collapsible');
			$('.card-header.order').addClass('clearfix collapsible-title card-header-custom');
			$('.card-body.order').addClass('collapse');
			$('edit-order-mobile').show();
			$('.edit-order-desktop').hide();		
		} else {
			$('.order-sticky').hide();
			$('edit-order-mobile').hide();
			$('.edit-order-desktop').show();	
			$('.card.delivery-summary.order').removeClass('collapsible');
			$('.card-header.order').removeClass('clearfix collapsible-title card-header-custom');
			$('.card-body.order').removeClass('collapse');
		}
		calculateStickyMargin();
	}, 250);
});

require('./components/spinner');